var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDjango03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2BA977;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.8,0h83.8v384.2c-42.9,8.1-74.6,11.3-108.8,11.3c-102.4-0.1-155.7-45.9-155.7-133.7 c0-84.6,56.5-139.6,144.1-139.6c13.6,0,24,1.1,36.5,4.3V0z M238.8,195.8c-9.8-3.2-17.9-4.3-28.3-4.3c-42.4,0-66.9,25.9-66.9,71.2 c0,44.1,23.4,68.5,66.4,68.5c9.3,0,16.8-0.5,28.8-2.1V195.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.8,132.6V325c0,66.3-5,98.1-19.5,125.6c-13.6,26.4-31.5,43.1-68.5,61.5l-77.8-36.7 c37-17.2,54.9-32.4,66.4-55.6c12-23.7,15.8-51.2,15.8-123.4V132.6H456.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    className: "st0",
    width: 83.8,
    height: 85.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango03);
export default __webpack_public_path__ + "static/media/Django-03.2ea2858e3155bbd1b1962cc6a9bed95d.svg";
export { ForwardRef as ReactComponent };